import Image1 from './11-lies.png';
import Image3 from './change-coming.jpg';
import Image4 from './crush-depth-cheribaby.jpg';
import Image5 from './maple-state.png';
import Image6 from './now-artwork.jpg';
import Image7 from './snowblind-cover.jpg';
import Image8 from './say-youll-believe.png';
import imgNotYourStory from './not-your-story.png';
import imgLoud17 from './Loud&17.png';
import imgScars from './scars.jpg';
import imgSuperman from './superman.jpg';
import imgOneSky from './onesky.jpg';
import imgSettleDown from './wont-settle-down.jpg';
import imgNeonNights from './neon-nights.jpg';
import imgBreathe from './Breathe.png'
import imgYellowLines from './yellow-lines.jpg'
import imgLeftInTheDeck from './leftInTheDeck.jpg';
import imgNotEvenLittleBit from './notEvenJustALittleBit.jpeg';
import imgSignificance from './significance.jpg';
import imgSYBRemix from './SYBRemix.jpg';

const images = [
    {image: imgSYBRemix, embed: '6EFerYvrPpLUlmKg5Fe7YD'},
    {image: imgNotEvenLittleBit, embed: '0e1hrvR54hs1qdh5htSMmo' },
    {image: imgLeftInTheDeck, embed: '4ZVOUOWfIMTjIvsjpXnMyy'},
    {image: imgSignificance, embed: '6JuidbsodUU5EeKJhrQw39'},
    {image: imgYellowLines, embed: '4PKdMmRRVHtlVwFqgPpW79'},
    {image: imgBreathe, embed: '3RtLpaU0a4zegliweJGWPZ'},
    {image: imgNeonNights , embed: '524TMqXYsL0QoZ3eV8iyhl' },
    {'image': imgSettleDown, 'embed': '1QrAxQZxC5hVZyakDKiOhS'},
    {'image': imgOneSky, 'embed': '7KSUMaHPaBs7Cy4iweG6lk'},
    {"image": imgSuperman, "embed": "01trKGpNGhIquQiXETnDId"},
    {"image": imgScars, "embed": "59ytT0GP5bKoJCCX8bsfiL"},
    {"image": imgLoud17, "embed": "1fYCAjCeUnvBJ2BvxYvOtb"},
    {"image": imgNotYourStory, "embed": "48slRypL18Nh0uY1rLjVkR"},
    {"image": Image3, "embed": "4zNX4cqZ9vUPT3LvWZe4Wf"},
    {"image": Image4, "embed": "2E82L2w1fY4r1yLT1LBxLC"},
    {"image": Image5, "embed": "4vu5gj1c1iVl8bn79XgIkP"},
    {"image": Image6, "embed": "4PMuN3Pd6m11qyNmXWsT7V"},
    {"image": Image7, "embed": "39pIEdsVE2d5MOW14jM7at"},
    {"image": Image8, "embed": "4ER7bWK1Sq5I59qidf41kb"},
    {"image": Image1, "embed": "4If3Qfdfi9whhGBgkV3bAu"}
]

export default images;